import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  filter(event) {
    event.preventDefault();
    const {label, value} = event.currentTarget.dataset;
    document.dispatchEvent(createCustomEvent("filter-triggered", this.element, {label, value}))
  }
};



// WEBPACK FOOTER //
// ./app/components/filters/assets/javascript/filters-pills-controller.js